const TermsOfService = () => {
    return (
        <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 max-w-3xl space-y-8 text-sm text-muted-foreground">
            <section>
                <h1 className="text-3xl font-semibold text-foreground mb-4">Terms of Service</h1>
                <p className="text-xs text-muted-foreground">Effective date: January 1, 2025</p>
            </section>

            <section className="space-y-3">
                <p>
                    These Terms of Service (“Terms”) govern your access to and use of the services provided by ProcessPipe, LLC
                    (“ProcessPipe”, “we”, “us”, or “our”), including the website and any related applications or content
                    (collectively, the “Services”). By using the Services, you agree to be bound by these Terms.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Acceptable Use</h2>
                <p>You agree not to:</p>
                <ul className="list-disc pl-6 space-y-1">
                    <li>Use the Services for illegal or unauthorized purposes</li>
                    <li>Violate any applicable laws or regulations</li>
                    <li>Interfere with or disrupt the integrity or performance of the Services</li>
                    <li>Attempt to gain unauthorized access to the Services or related systems</li>
                </ul>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">User Content</h2>
                <p>
                    You retain ownership of any content you submit to the Services (“User Content”). By submitting User Content,
                    you grant ProcessPipe a worldwide, non-exclusive, royalty-free license to use, reproduce, distribute, and
                    display that content for the purpose of operating and improving the Services.
                </p>
                <p>
                    You are solely responsible for your User Content and represent that you have the rights necessary to provide
                    it.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Intellectual Property</h2>
                <p>
                    The Services, including text, graphics, logos, and software, are owned by ProcessPipe or its licensors and are
                    protected by intellectual property laws. You may not copy, modify, or distribute any part of the Services
                    without our prior written consent.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Third-Party Services</h2>
                <p>
                    The Services may contain links to third-party sites or services. ProcessPipe is not responsible for the
                    content, policies, or practices of third parties, and your use of third-party services is at your own risk.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Disclaimer of Warranties</h2>
                <p>
                    The Services are provided “as is” and “as available” without warranties of any kind, express or implied.
                    ProcessPipe disclaims all warranties, including merchantability, fitness for a particular purpose, and
                    non-infringement.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Limitation of Liability</h2>
                <p>
                    To the fullest extent permitted by law, ProcessPipe will not be liable for any indirect, incidental,
                    consequential, or punitive damages arising out of or related to your use of the Services.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Indemnification</h2>
                <p>
                    You agree to indemnify and hold ProcessPipe harmless from any claims, damages, or expenses arising from your
                    use of the Services or violation of these Terms.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Termination</h2>
                <p>
                    We may suspend or terminate your access to the Services at any time, with or without cause. Upon termination,
                    all provisions of these Terms will remain in effect, including ownership rights, warranty disclaimers, and
                    limitations of liability.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Governing Law</h2>
                <p>
                    These Terms are governed by the laws of the State of Wisconsin, without regard to its conflict of law
                    principles. Any disputes will be resolved in the state or federal courts located in Wisconsin.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Changes to These Terms</h2>
                <p>
                    We may update these Terms from time to time. If we make material changes, we will notify you by revising the
                    effective date at the top of the Terms and, in some cases, by providing additional notice.
                </p>
            </section>

            <section className="space-y-3">
                <h2 className="text-xl font-semibold text-foreground">Contact Us</h2>
                <p>
                    If you have questions about these Terms, please contact ProcessPipe, LLC at legal@processpipe.com.
                </p>
            </section>

            <section className="text-xs text-muted-foreground border-t border-border pt-6">
                <p>© 2025 ProcessPipe, LLC. All rights reserved.</p>
            </section>
        </main>
    )
}

export default TermsOfService

